import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { ActivityModal } from './ActivityModal.tsx';
import { useState } from 'react';
import { API_BASE_URL, authFetch } from '../apiClient.ts';

type EditActivityButtonWithFetchProps = {
  keyName: string;
  resource: string;
  recordId: number;
  onSaved?: () => void;
};

export const EditActivityButtonWithFetch = ({
  keyName,
  resource,
  recordId,
  onSaved
}: EditActivityButtonWithFetchProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [record, setRecord] = useState<any | null>(null);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpen = async () => {
    setIsLoading(true);
    try {
      const res = await authFetch(`${API_BASE_URL}/${resource}/${recordId}`);
      const data = await res.json();
      setRecord(data);
      setOpen(true);
    } catch (err) {
      console.error('Failed to fetch record for editing activity:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Tooltip title="Edit activity">
        <span>
          <IconButton
            onClick={handleOpen}
            size="small"
            color="primary"
            aria-label="Edit activity"
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={18} /> : <EditOutlinedIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
      <ActivityModal
        open={open}
        setOpen={setOpen}
        initialRecord={record}
        keyName={keyName}
        resource={resource}
        onSaved={onSaved}
      />
    </>
  );
};
